<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Certifikati pridelovalca</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
              <pridelovalec :pridelovalec="pridelovalec">
          </pridelovalec>
            
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <Grid  
                       
                      
                        :data-items="gridData"
                        :columns="columns"
                          @datastatechange="dataStateChange"
                       
                       :edit-field="'inEdit'"
                        @itemchange="itemChange"

                      
                         :row-render="rowRenderFunction"
                      
                        

                         
                        
                                               >


                 <template v-slot:certifikatLink="{props}">
                    <td>
                      <a
                        class="k-primary k-button k-grid-edit-command" v-if="props.dataItem.id >= 0 && props.dataItem.jeaktivna"
                        :href="'/interno/certifikat/'+props.dataItem.id" target="_blank" title="Poglej">
                         <font-awesome-icon icon="certificate"/> &nbsp;
                         
                    </a>
                </td></template>
                  
                    <template v-slot:shranigumb="{props}">
                        <td>
                              <div class="km-widget km-buttongroup k-widget k-button-group">
                      <button
                             :disabled="editDisabled||props.dataItem.izdan||props.dataItem.veljaven==2"
                                title="Shrani certifikat"
                                class="k-button k-primary"
                                @click="shraniCertifikat(props.dataItem)"
                            >
                                <span v-if="!props.dataItem.jeaktivna">Povrni</span>
                                <span v-else>Shrani</span>
                            </button>
                         <button
                             :disabled="!props.dataItem.jeaktivna||props.dataItem.izdan||props.dataItem.veljaven==2"
                                title="Briši certifikat"
                                class="k-button k-primary"
                                @click="brisiCertifikat(props.dataItem)"
                            >
                                Briši
                            </button>
                       
                        </div>
                        </td>
                    </template>
                    <template v-slot:statusshranjevanja="{props}">
                        <td>
                        <span title="Status shranjevanja" v-if="props.dataItem.saved!=undefined" :class="[props.dataItem.saved?'action_success':'action_error','k-badge','k-badge-solid','k-badge-md','k-badge-pill']">
                        <font-awesome-icon v-if="props.dataItem.saved" icon="check" class='action_success'/> 
                        <font-awesome-icon v-else icon="times"/> 
                        </span> 
                        </td>
                    </template>

                    <template v-slot:izdajgumb="{props}">
                        <td>
                              <div class="km-widget km-buttongroup k-widget k-button-group">
                      <button
                             :disabled="editDisabled||!props.dataItem.jeaktivna||props.dataItem.veljaven==0||props.dataItem.veljaven==2||!(props.dataItem.saved||props.dataItem.saved==undefined)"
                                title="Izdaj certifikat"
                                class="k-button k-primary"
                                @click="izdajCertifikat(props.dataItem)"
                            >
                                <span v-if="props.dataItem.izdan">Izdan</span>
                                <span v-else>Izdaj</span>
                            </button>
                         <button v-if="props.dataItem.izdan||props.dataItem.veljaven==2"
                             :disabled="!props.dataItem.jeaktivna"
                                title="Umakni certifikat"
                                class="k-button k-primary"
                                @click="umakniCertifikat(props.dataItem)"
                            >
                                Umakni
                            </button>
                       
                        </div>
                        </td>
                    </template>
                 <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                           <!--
                           <button
                                title="Omogoči urejanje"
                                class="k-button k-primary"
                               
                            >
                                Omogoči urejanje
                            </button>
                          -->
                        <button :disabled="editDisabled"
                                title="Dodaj"
                                class="k-button k-primary"
                                @click="insert">
                                Dodaj certifikat
                        </button>
                      
                        
                            
                           
                                 <button class="k-button k-primary"  title="Nazaj" @click="nazaj" >Nazaj</button>
                            
                            <!--
                        <button
                                title="Export to Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                        <button
                                title="Obrazec za površine"
                                class="k-button k-primary"
                                @click="kontrolniList"
                            >
                                Obrazec za površine
                            </button>
                          -->
                        </div>
                            
                        </toolbar>
                         <GridNoRecords >
                    <div v-if="dataLoading" class="k-loading-mask loadingIconSpace">
                      <span class='k-loading-text'></span>
                      <div class='k-loading-image'></div>
                      <div class='k-loading-color'></div>
                      
                    </div>
                    <div v-else>
                      Ni podatkov!
                    </div>
                    </GridNoRecords>
                    </Grid>

                    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
import '@progress/kendo-ui' // This will import the entire Kendo UI library
// As an alternative, you could import only the scripts that are used by a specific widget:
// import '@progress/kendo-ui/js/kendo.treelist' // Imports only the TreeList script and its dependencies

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
//import { TreeList, TreeListInstaller } from '@progress/kendo-treelist-vue-wrapper'
import sifrantKulture from './support/kulture-data';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
import SifrantKulturDownCell from './support/SifrantKulturDropDown';
import PridelovalecKratko from './support/PridelovalecKratko';
//import { sifrantService } from '../services';


//import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
//import numbers from 'cldr-numbers-full/main/es/numbers.json';
//load(
    //likelySubtags,
    //numbers);

import { process } from '@progress/kendo-data-query';
import moment from 'moment'




//Vue.component('Grid', Grid);
//Vue.component('toolbar', GridToolbar);

//var kulture=[{id:1,kulturaid:1,naziv:"A",povrsina:"1",kolicina:"2",enota:"kg",datumdolocitvestatusa:new Date(),datumveljavnostistatusa:null,status:""},
             //{id:2,kulturaid:1,naziv:"B",povrsina:"2",kolicina:"3",enota:"kg",datumdolocitvestatusa:null,datumveljavnostistatusa:null,status:""}
              //];
              var kulture=[];


export default {
  components:{
        'ukaznigumbiknt': StatusCommandCell,
     
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
       'pridelovalec':PridelovalecKratko
  },
  props:['sezona','pridelovalecid'],
    data () {
        return {
            //defaultItemSezona: { sezona: 'Izberi sezono...'},
            sifrantTree:{},
            dataLoading:false,
            
            dataSezona:this.sezona,
           
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
            columns: [
            //    { field: "ime", title:"Ime",editable:false,width: "150px"},
                //{ field: "kmgmid", title:"KMG-MID",editable:false,width: "150px"},
                //{ field: "naslov", title:"Naslov",editable:false,width: "250px"},

                //{ field: "postnastevilka", title:"Pošta",editable:false,width: "130px"},
                //iz idja naložit šifro
                { field: "stevilkacertifikata", title:"Številka",width: "130px"},
                { field: "datumizdaje", title:"Datum izdaje", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true}},
                { field: "datumveljavnosti", title:"Datum veljavnosti", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true}},
                { field: "informacije", title:"Informacije",},
                { field: "veljaven", title:"Veljaven", editor: 'boolean',width: "70px", cell:this.veljavenIcon,validation: { required: true}},
                { title: "Poglej certifikat", cell: 'certifikatLink',filterable:false,columnMenu: null,width:"120px",sortable:false},
                //{ cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
                { title: "Shrani/Briši", cell: 'shranigumb', hidden:this.editDisabled,width:"140px",sortable:false },
                { title:'Shranjen', cell: 'statusshranjevanja',  hidden:this.editDisabled,width:"80px",sortable:false },
                { title: "Izdaj/Umakni", cell: 'izdajgumb', hidden:this.editDisabled,width:"140px",sortable:false },
                //{ cell: 'brisigumb', width: '80px', hidden:this.editDisabled },
              
                //  { field: "status", title:"Status", cell:StatusCell},
                //gerk view link http://rkg.gov.si/GERK/WebViewer/#query=GERK_SDO:GERK_PID:4605424
                //kmg view
                //http://rkg.gov.si/GERK/WebViewer/#KMG=100735069
                //{ field: 'stanje', title: '', cell: this.cellFunction },
               // { field: "statuspridelovalca", title:"Status",editable:false,width: "200px"},
                //{ field: "kontrolnaorganizacija", title:"V kontroli pri",editable:false,width: "200px"},
                //{ field: "jeaktivna", title:"Aktivna",editable:false,filter:'boolean',width: "100px"},
                
                
                //{ field: "pisanje", title:"Dovoli pisanje",editor: 'boolean',filter:'boolean',width: "150px" },
                //{ cell: CommandCell, width: '180px',filterable:false }
            ],
          

           

        }
    },
      computed: {

        //...mapState('sifrant', ['sifrant']),
        editDisabled(){
          return (this.pridelovalec.pisanje==0)
        },
        ...mapState({gridData(state) {
         // console.log(state.kultura);
         //make editable?
          return state.certifikat.certifikat;
        }}),

        ...mapState('pridelava', ['pridelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
      
           },
    created () {

      //potegni šifrant iz sifrantstore
     /* var groupedAreas = [];
dataItems.map(function(d) {
  if(groupedAreas.filter(function(item, i) {
   return item.areaName === d.AreaName; 
  }).length === 0) {
    groupedAreas.push({ areaName: d.AreaName, subsidiaries:  dataItems.filter(function(r) { return r.AreaName === d.AreaName; }) });
  }
});*/
this.dataSezona={sezona:this.sezona};
this.naloziPodatke();

      
    },
  


    methods: {
        ...mapActions('certifikat', ['load','save','saveCert']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('certifikat',['update',"add","remove","makeEditable",'replace']),
        ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),
        //...mapActions('sifrant', ['load']),
         veljavenIcon: function (h, defaultElement , props, listeners ) {
            if(props.dataItem.inEdit)
                return defaultElement;

            let veljaven=h('font-awesome-icon',{props:{icon:"times"}});
            if(props.dataItem.veljaven)
                veljaven=h('font-awesome-icon',{props:{icon:"check"}},{class:{"action_success":true}});
            let veljavenWrapper=h('span', {class:{
                'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!props.dataItem.veljaven,"action_success":props.dataItem.veljaven}}, [veljaven]);
            return h('td', {attrs:{colspan:1}}, [veljavenWrapper]);
        },
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jeaktivna!=1)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
        naloziPodatke: function(){
          this.dataLoading=true;
        this.replace([]);
          this.loadOne({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid}).then(()=>{
        

        this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid,makeEditable:!this.editDisabled}).then(

          data=>{this.dataLoading=false;},


          error=>{console.log("tukaj sem!!!");this.dataLoading=false;});
        });
      
        },
        
        itemChange: function (e) {
            //const updatedData  = this.gridData.slice();
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          e.dataItem[e.field] = e.value;
          if(e.field=="veljaven")
            e.dataItem[e.field]=e.value?1:0;
          
         //   const item = this.update(e.dataItem);
            //item[e.field] = e.value;
            //this.repalce(updatedData);
            Vue.set(e.dataItem,'saved',false);
            
        },
         insert() {
            const dataItem = { inEdit: true,jeaktivna:1,
                  datumveljavnosti:new Date(this.dataSezona.sezona*1+1,11,31),datumizdaje:new Date(),veljaven:1,sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid                
                   };
            //const newproducts = this.gridData.slice();
            //newproducts.unshift(dataItem);
            this.add(dataItem);
          //  this.repalce(newproducts);
        },
     
      
        shraniCertifikat: function(certifikat) {
            certifikat.jeaktivna=1;
            Vue.set(certifikat,'veljaven',certifikat.veljaven>0?1:0);
            this.saveCert({certifikat:certifikat});
        },
        brisiCertifikat: function(certifikat) {
            certifikat.jeaktivna=0;
            this.saveCert({certifikat:certifikat});
        },
        izdajCertifikat: function(certifikat) {
            certifikat.jeaktivna=1;
            Vue.set(certifikat,'izdan',1);
            Vue.set(certifikat,'inEdit',false);
            Vue.set(certifikat,'veljaven',2);
            
            this.saveCert({certifikat:certifikat});
            //certifikat.veljaven=2;
        },
        umakniCertifikat: function(certifikat) {
            //certifikat.jeaktivna=0;
            Vue.set(certifikat,'izdan',0);
            Vue.set(certifikat,'inEdit',true);
            Vue.set(certifikat,'veljaven',3);
            this.saveCert({certifikat:certifikat});
            //this.saveCert({certifikat:certifikat});
        },
        saveItem: function(e) {
          console.log(e.dataItem);
          for (const value in e.dataItem.newValues){
            e.dataItem[value]=e.dataItem.newValues[value];
          }
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = 1;
          //  const data = this.gridData.slice();
            this.update(e.dataItem);
            //e.dataItem.id = this.update(kulture, e.dataItem).id;
        },
      
       sezonaChange(event) {
             const sezona = event.value;
            this.dataSezona=sezona;
            this.loadIdPoSezoni({sezona:sezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'certifikat', params: {sezona:sezona.sezona,pridelovalecid:pridelovalec.id} });
             this.naloziPodatke();
              });



        },
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
                 //  console.log(this.skip);
            this.dataResult = process(this.gerk, {});
           // console.log(this.dataResult);

        },
      
        shraniKulture () {
          //  this.$router.go(-1);
          //console.log(this.dataResult);
        

              this.save();
      //         this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid});

                     
        },
       
        /*
        changeStatus: function (e) {
            console.log("Gerk change!!!");
            console.log(e.dataItem);
          //  Vue.set(e.dataItem, 'inEdit', true);
        },
*/
        //do doli
        
    }
};
</script>

